module.exports = __webpack_public_path__ + "static/media/3D打印机械爪.2527001a.png";